import { AppBar, Tab, Tabs } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";

export interface DialogTabsMenuProps<T extends string> {
  tabs: readonly T[];
  value: T;
  labels: Record<T, string>;
  basePath: string;
}

// Общая реализация вкладочного диалога (вынесена из StreamTabsMenu.tsx):
// AppBar + Tabs с Tab-как-Link, значение вкладки живёт в ?tab=, диалог не
// размонтируется при переключении (deep-linking на вкладку работает).
export function DialogTabsMenu<T extends string>({
  tabs,
  value,
  labels,
  basePath,
}: DialogTabsMenuProps<T>) {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <AppBar position="static" color="default" elevation={0}>
      <Tabs value={value} scrollButtons="auto" variant="scrollable">
        {tabs.map((name) => {
          const linkParams = new URLSearchParams(searchParams);
          linkParams.set("tab", name);
          return (
            <Tab
              key={name}
              value={name}
              label={labels[name]}
              component={Link}
              to={`${basePath}?${linkParams.toString()}`}
              onClick={(event) => {
                event.preventDefault();
                searchParams.set("tab", name);
                setSearchParams(searchParams);
              }}
            />
          );
        })}
      </Tabs>
    </AppBar>
  );
}
